//---------------------------------------------------
//  Nom du fichier : NotConnected.js 
//
//  Description: Component quand l'utilisateur n'est pas connecté
//
//  Auteur: Vega Laliberté et Alek Del Balso
//---------------------------------------------------

import './NotConnected.css';
import './btn.css';
import { useTranslation } from "react-i18next";
import Button from '@mui/material/Button';

function NotConnected({ set_login, set_SignIn, _login, _signIn}) {

  const toggle_login = () => {
    set_login(!_login)
    set_SignIn(false)
  }

  const toggle_singIn = () => {
    set_SignIn(!_signIn)
    set_login(false)
  }

  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const toggleLang = currentLang === "en" ? "fr" : "en";
  const buttonText = toggleLang.toUpperCase();

  return (
    <>
      <div className='notConnected'>
        <Button variant="outlined" id='signin' className='btBase' onClick={toggle_singIn}>{t('not_connected_register')}</Button>
        <Button variant="outlined" id='login' className='btBase' onClick={toggle_login}>{t('not_connected_login')}</Button>
      </div>
      <Button variant="outlined" id='lang_not_connected' className='btBase' onClick={() => i18n.changeLanguage(toggleLang)}>{buttonText}</Button>
    </>
  );
}

// Exportation du composant pour l'utiliser ailleurs
export default NotConnected;